export const translations = {
  en: {
    nav: {
      about: 'About',
      destinations: 'Destinations',
      properties: 'Properties',
      partners: 'Partners',
      contact: 'Contact'
    },
    hero: {
      title: 'Maison Eze',
      subtitle: 'Connecting UHNWI to Extraordinary Properties Worldwide',
      cta: 'Explore Properties'
    },
    about: {
      title: 'Discreet. Global. Exclusive.',
      description: 'Maison Eze is a boutique private network serving ultra-high-net-worth individuals, family offices, and discerning private investors seeking exceptional properties across the world\'s most coveted destinations.',
      directAccess: 'Direct Access',
      directAccessDesc: 'Exclusive connections to premier developers and off-market opportunities.',
      globalReach: 'Global Reach',
      globalReachDesc: 'Curated properties in France, Greece, Serbia, and Morocco.',
      discretion: 'Absolute Discretion',
      discretionDesc: 'Private transactions handled with utmost confidentiality.'
    },
    destinations: {
      title: 'Our Destinations',
      discover: 'Discover'
    },
    properties: {
      title: 'Signature Properties',
      subtitle: 'A curated selection of exceptional properties across our most prestigious locations',
      bedrooms: 'Bedrooms'
    },
    partners: {
      title: 'Our Partners',
      subtitle: 'We collaborate with the world\'s finest interior designers and developers',
      visitWebsite: 'Visit Website'
    },
    contact: {
      title: 'Join Our Private Network',
      subtitle: 'Exclusive access for verified UHNWI, family offices, and accredited investors',
      fullName: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      investmentCapacity: 'Investment Capacity',
      selectRange: 'Select range',
      preferredDestinations: 'Preferred Destinations',
      destinationsPlaceholder: 'e.g., France, Greece, Marrakesh',
      message: 'Message',
      nda: 'By submitting this form, you acknowledge that all information will be treated with strict confidentiality and subject to our non-disclosure agreement. Our team conducts verification for all network members.',
      submit: 'Submit Inquiry',
      thankYou: 'Thank you for your interest',
      thankYouMessage: 'Our team will contact you within 48 hours.',
      inquiryNumber: 'Inquiry'
    },
    footer: {
      description: 'Connecting UHNWI to extraordinary properties worldwide',
      contactTitle: 'Contact',
      followTitle: 'Follow Us',
      copyright: 'Maison Eze. All rights reserved. Discreet. Global. Exclusive.'
    }
  },
  ru: {
    nav: {
      about: 'О нас',
      destinations: 'Направления',
      properties: 'Недвижимость',
      partners: 'Партнёры',
      contact: 'Контакты'
    },
    hero: {
      title: 'Maison Eze',
      subtitle: 'Соединяем UHNWI с исключительной недвижимостью по всему миру',
      cta: 'Изучить объекты'
    },
    about: {
      title: 'Деликатно. Глобально. Эксклюзивно.',
      description: 'Maison Eze — бутиковая частная сеть для владельцев сверхкрупного капитала, семейных офисов и требовательных частных инвесторов, ищущих выдающиеся объекты в самых желанных направлениях мира.',
      directAccess: 'Прямой доступ',
      directAccessDesc: 'Эксклюзивные связи с ведущими девелоперами и вне­рыночными предложениями.',
      globalReach: 'Глобальный охват',
      globalReachDesc: 'Курируемые объекты во Франции, Греции, Сербии и Марокко.',
      discretion: 'Абсолютная конфиденциальность',
      discretionDesc: 'Частные сделки с соблюдением максимальной секретности.'
    },
    destinations: {
      title: 'Наши направления',
      discover: 'Узнать больше'
    },
    properties: {
      title: 'Знаковые объекты',
      subtitle: 'Курируемая подборка исключительных объектов в наших самых престижных локациях',
      bedrooms: 'Спальни'
    },
    partners: {
      title: 'Наши партнёры',
      subtitle: 'Мы сотрудничаем с лучшими мировыми дизайнерами интерьеров и девелоперами',
      visitWebsite: 'Посетить сайт'
    },
    contact: {
      title: 'Присоединиться к нашей закрытой сети',
      subtitle: 'Эксклюзивный доступ для верифицированных UHNWI, семейных офисов и квалифицированных инвесторов',
      fullName: 'Полное имя',
      email: 'Электронная почта',
      phone: 'Номер телефона',
      investmentCapacity: 'Объём инвестиций',
      selectRange: 'Выберите диапазон',
      preferredDestinations: 'Предпочтительные направления',
      destinationsPlaceholder: 'например, Франция, Греция, Марракеш',
      message: 'Сообщение',
      nda: 'Отправляя эту форму, вы подтверждаете, что вся информация будет обрабатываться строго конфиденциально и в рамках нашего соглашения о неразглашении (NDA). Наша команда проводит проверку всех участников сети.',
      submit: 'Отправить запрос',
      thankYou: 'Спасибо за ваш интерес',
      thankYouMessage: 'Наша команда свяжется с вами в течение 48 часов.',
      inquiryNumber: 'Запрос'
    },
    footer: {
      description: 'Соединяем UHNWI с исключительной недвижимостью по всему миру',
      contactTitle: 'Контакты',
      followTitle: 'Следите за нами',
      copyright: 'Maison Eze. Все права защищены. Деликатно. Глобально. Эксклюзивно.'
    }
  },
  zh: {
    nav: {
      about: '關於',
      destinations: '目的地',
      properties: '物業',
      partners: '合作夥伴',
      contact: '聯絡'
    },
    hero: {
      title: 'Maison Eze',
      subtitle: '連結超高淨值人士與全球臻稀資產',
      cta: '探索物業'
    },
    about: {
      title: '低調。全球。專屬。',
      description: 'Maison Eze 是一家精品私密網絡，服務超高淨值人士、家族辦公室與具鑑賞力的私人投資者，協助您於全球最受追捧的目的地甄選卓越物業。',
      directAccess: '直接通道',
      directAccessDesc: '與頂尖開發商及非公開／場外機會的專屬對接。',
      globalReach: '全球版圖',
      globalReachDesc: '精選位於法國、希臘、塞爾維亞與摩洛哥的優質資產。',
      discretion: '絕對私密',
      discretionDesc: '所有私人交易皆以最高機密標準處理。'
    },
    destinations: {
      title: '我們的目的地',
      discover: '探索'
    },
    properties: {
      title: '典藏臻品',
      subtitle: '於我們最尊貴的據點精選非凡物業',
      bedrooms: '臥房'
    },
    partners: {
      title: '合作夥伴',
      subtitle: '我們與全球頂尖的室內設計師與開發商深度合作',
      visitWebsite: '瀏覽網站'
    },
    contact: {
      title: '加入私密網絡',
      subtitle: '僅向已驗證的超高淨值人士、家族辦公室與合格投資者專屬開放',
      fullName: '姓名',
      email: '電子郵件',
      phone: '聯絡電話',
      investmentCapacity: '投資額度',
      selectRange: '請選擇範圍',
      preferredDestinations: '意向目的地',
      destinationsPlaceholder: '例如：法國、希臘、馬拉喀什',
      message: '留言',
      nda: '提交此表單即表示您確認所有資訊將被嚴格保密，並受我們的保密協議（NDA）所規範。我們的團隊將對所有網絡成員進行資格審核。',
      submit: '提交諮詢',
      thankYou: '感謝您的關注',
      thankYouMessage: '我們的團隊將於 48 小時內與您聯繫。',
      inquiryNumber: '諮詢'
    },
    footer: {
      description: '連結超高淨值人士與全球臻稀資產',
      contactTitle: '聯絡',
      followTitle: '追蹤我們',
      copyright: 'Maison Eze。版權所有。低調。全球。專屬。'
    }
  },
  ar: {
    nav: {
      about: 'من نحن',
      destinations: 'الوجهات',
      properties: 'العقارات',
      partners: 'الشركاء',
      contact: 'اتصل بنا'
    },
    hero: {
      title: 'Maison Eze',
      subtitle: 'ربط أصحاب الثروات الفائقة بعقارات استثنائية حول العالم',
      cta: 'استكشف العقارات'
    },
    about: {
      title: 'متحفّظون. عالميون. حصريون.',
      description: 'Maison Eze شبكة خاصة بوتيكية تخدم أصحاب الثروات الفائقة، ومكاتب العائلات، والمستثمرين الخواص المتطلّبين الباحثين عن عقارات مميّزة في أكثر الوجهات العالمية تفضيلاً.',
      directAccess: 'وصول مباشر',
      directAccessDesc: 'روابط حصرية مع كبار المطوّرين وفرص خارج السوق.',
      globalReach: 'انتشار عالمي',
      globalReachDesc: 'عقارات مُنتقاة في فرنسا واليونان وصربيا والمغرب.',
      discretion: 'سرّية مطلقة',
      discretionDesc: 'تنفيذ معاملات خاصة بأعلى درجات السرّية.'
    },
    destinations: {
      title: 'وجهاتنا',
      discover: 'اكتشف'
    },
    properties: {
      title: 'العقارات المميّزة',
      subtitle: 'باقة مُنتقاة من العقارات الاستثنائية في أكثر مواقعنا رُقياً',
      bedrooms: 'غرف النوم'
    },
    partners: {
      title: 'شركاؤنا',
      subtitle: 'نتعاون مع نخبة مصممي الديكور الداخلي والمطوّرين على مستوى العالم',
      visitWebsite: 'زيارة الموقع'
    },
    contact: {
      title: 'انضم إلى شبكتنا الخاصة',
      subtitle: 'وصول حصري لأصحاب الثروات الفائقة الموثَّقين، ومكاتب العائلات، والمستثمرين المعتمدين',
      fullName: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      investmentCapacity: 'القدرة/حجم الاستثمار',
      selectRange: 'اختر النطاق',
      preferredDestinations: 'الوجهات المفضّلة',
      destinationsPlaceholder: 'على سبيل المثال: فرنسا، اليونان، مراكش',
      message: 'رسالة',
      nda: 'بتقديم هذا النموذج، فإنك تقرّ بأن جميع المعلومات ستُعامل بسرّية تامة وتخضع لاتفاقية عدم الإفصاح الخاصة بنا. يقوم فريقنا بإجراء التحقّق لجميع أعضاء الشبكة.',
      submit: 'إرسال الاستفسار',
      thankYou: 'شكراً لاهتمامك',
      thankYouMessage: 'سيتصل بك فريقنا خلال 48 ساعة.',
      inquiryNumber: 'استفسار'
    },
    footer: {
      description: 'ربط أصحاب الثروات الفائقة بعقارات استثنائية حول العالم',
      contactTitle: 'اتصل بنا',
      followTitle: 'تابعنا',
      copyright: 'ميزون إيز. جميع الحقوق محفوظة. متحفّظون. عالميون. حصريون.'
    }
  }
};

export const getTranslation = (lang = 'en') => {
  return translations[lang] || translations.en;
};